// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	font-family: 'Open Sans', sans-serif;
	background: #333333;		
	color: #CCCCCC;
	margin: 0;
	padding: 0;
}
div.content {
	margin: 20px 20px 20px 35px;
}
sup { font-size: 60%; }
a,
a:link,
a:visited
{
	color: #CCCC66;
	text-decoration:none;
	outline: none;
}
a:hover {
	color: #FFFF99;
	text-decoration:underline;
	outline: none;
}
a:active {
	color: #FFFF99;
	text-decoration:none;
	outline: none;
}
#main {
	padding-top: 10px;
	font-size: small;
}
#banner {
	color:#CC9933;
	font-size:30pt;
	font-weight:bold;
}
#bannercaption {
	font-weight:bold;
	background:#333;
	margin-bottom: 15px;
	margin-top: 4px;
}
#side {
	float: right;
	width: 25%;
	margin-left: 20px;
}
.sideitem {
	font-size: x-small;   
	padding: 2px; 
	padding-left: 12px;
	line-height:140%;				
}
.sideitem img {
	padding: 5px 0;
}
.sideitem a.clickable:hover {
	background: #555555;
	cursor: pointer;
}
.sidetitle {
	font-size: x-small;
	font-weight:normal;
	line-height:140%;				
	padding: 2px;
	padding-left: 12px;
	padding-top: 20px;
	border-bottom: 1px solid #666;
}
.copyright {
	font-size: 0.5em;
	color: rgb(133, 133, 133);
}
#side-button {
	position: absolute;
	top: 1rem;
	right: 4%;
	font-size: 1.5rem;
	display: none;
}
span.monospace {
	font-family: monospace;
}
@media only screen and (max-width: 960px) {
	div.content {
		margin: 2% 2% 2% 3%;
	}
	#banner {
		font-size:5vw;
	}
	#side-button {
		display: block
	}
	#side-button:hover {
		cursor: pointer;
	}
	#side {
		position: absolute;
		top: 4rem;
		right: 4%;
		float: none;
		width: 300px;
		z-index: 11;
		display: none;
		background:#111;
		border: 1px solid #696969;
		padding: 0.5rem;
	}
	#side.side-show {
		display: block;
	}
	#side .sidetitle, #side .sideitem {
		font-size: small;
	}
}
`, "",{"version":3,"sources":["webpack://./src/css/styles-site.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;CACpC,mBAAmB;CACnB,cAAc;CACd,SAAS;CACT,UAAU;AACX;AACA;CACC,2BAA2B;AAC5B;AACA,MAAM,cAAc,EAAE;AACtB;;;;CAIC,cAAc;CACd,oBAAoB;CACpB,aAAa;AACd;AACA;CACC,cAAc;CACd,yBAAyB;CACzB,aAAa;AACd;AACA;CACC,cAAc;CACd,oBAAoB;CACpB,aAAa;AACd;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,YAAY;CACZ,UAAU;CACV,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,6BAA6B;AAC9B;AACA;CACC,gBAAgB;CAChB,yBAAyB;AAC1B;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,iBAAiB;CACjB,aAAa;AACd;AACA;CACC,sBAAsB;AACvB;AACA;CACC;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC;CACD;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,eAAe;CAChB;CACA;EACC,cAAc;CACf;CACA;EACC,gBAAgB;CACjB;AACD","sourcesContent":["body {\n\tfont-family: 'Open Sans', sans-serif;\n\tbackground: #333333;\t\t\n\tcolor: #CCCCCC;\n\tmargin: 0;\n\tpadding: 0;\n}\ndiv.content {\n\tmargin: 20px 20px 20px 35px;\n}\nsup { font-size: 60%; }\na,\na:link,\na:visited\n{\n\tcolor: #CCCC66;\n\ttext-decoration:none;\n\toutline: none;\n}\na:hover {\n\tcolor: #FFFF99;\n\ttext-decoration:underline;\n\toutline: none;\n}\na:active {\n\tcolor: #FFFF99;\n\ttext-decoration:none;\n\toutline: none;\n}\n#main {\n\tpadding-top: 10px;\n\tfont-size: small;\n}\n#banner {\n\tcolor:#CC9933;\n\tfont-size:30pt;\n\tfont-weight:bold;\n}\n#bannercaption {\n\tfont-weight:bold;\n\tbackground:#333;\n\tmargin-bottom: 15px;\n\tmargin-top: 4px;\n}\n#side {\n\tfloat: right;\n\twidth: 25%;\n\tmargin-left: 20px;\n}\n.sideitem {\n\tfont-size: x-small;   \n\tpadding: 2px; \n\tpadding-left: 12px;\n\tline-height:140%;\t\t\t\t\n}\n.sideitem img {\n\tpadding: 5px 0;\n}\n.sideitem a.clickable:hover {\n\tbackground: #555555;\n\tcursor: pointer;\n}\n.sidetitle {\n\tfont-size: x-small;\n\tfont-weight:normal;\n\tline-height:140%;\t\t\t\t\n\tpadding: 2px;\n\tpadding-left: 12px;\n\tpadding-top: 20px;\n\tborder-bottom: 1px solid #666;\n}\n.copyright {\n\tfont-size: 0.5em;\n\tcolor: rgb(133, 133, 133);\n}\n#side-button {\n\tposition: absolute;\n\ttop: 1rem;\n\tright: 4%;\n\tfont-size: 1.5rem;\n\tdisplay: none;\n}\nspan.monospace {\n\tfont-family: monospace;\n}\n@media only screen and (max-width: 960px) {\n\tdiv.content {\n\t\tmargin: 2% 2% 2% 3%;\n\t}\n\t#banner {\n\t\tfont-size:5vw;\n\t}\n\t#side-button {\n\t\tdisplay: block\n\t}\n\t#side-button:hover {\n\t\tcursor: pointer;\n\t}\n\t#side {\n\t\tposition: absolute;\n\t\ttop: 4rem;\n\t\tright: 4%;\n\t\tfloat: none;\n\t\twidth: 300px;\n\t\tz-index: 11;\n\t\tdisplay: none;\n\t\tbackground:#111;\n\t\tborder: 1px solid #696969;\n\t\tpadding: 0.5rem;\n\t}\n\t#side.side-show {\n\t\tdisplay: block;\n\t}\n\t#side .sidetitle, #side .sideitem {\n\t\tfont-size: small;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
